import { useContext } from "react";
import { AuthContext } from "../contexts/AuthenticationContext";

const useAuthentication = () => {
  const authData = useContext(AuthContext);
  return authData;
};

export default useAuthentication;
